import React from "react";

/**
 * Bonded Thru Cancer brand mark.
 * Uses the official transparent-background PNG (background-removed at build time).
 * Sits natively on the page background — no white box, no container.
 * Sharp at retina sizes (1211x508 source).
 */
const LOGO_SRC = "/img/btc-logo.png";

export default function BtcLogo({ className = "", title = "Bonded Thru Cancer" }) {
  return (
    <img
      src={LOGO_SRC}
      alt={title}
      className={className}
      draggable={false}
      style={{ background: "transparent" }}
    />
  );
}
